import { memo } from "react"

type SvgProps = React.ComponentPropsWithoutRef<"svg">

export const CaseSensitiveIcon = memo(({ className, ...props }: SvgProps) => {
  return (
    <svg
      width="24"
      height="24"
      className={className}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.61132 5.00586C6.86822 5.02489 7.11659 5.11042 7.33202 5.25391C7.57828 5.41804 7.7708 5.65169 7.88476 5.9248L11.9228 15.6152C12.1351 16.1249 11.8944 16.7104 11.3848 16.9229C10.875 17.1353 10.2896 16.8936 10.0771 16.3838L9.08397 14H3.91698L2.92284 16.3848C2.7102 16.8942 2.12483 17.1352 1.61522 16.9229C1.10565 16.7104 0.86489 16.1249 1.07714 15.6152L5.1162 5.9248L5.1621 5.82422C5.27859 5.5943 5.45343 5.39755 5.66894 5.25391L5.76269 5.19629C5.98724 5.06944 6.24182 5.00195 6.50097 5.00195L6.61132 5.00586ZM4.74999 12H8.24999L6.49999 7.80078L4.74999 12Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 8C22.5523 8.00001 23 8.44772 23 9V16C23 16.5523 22.5523 17 22 17C21.5246 17 21.127 16.6682 21.0254 16.2236C20.3052 16.713 19.4363 17 18.5 17C16.0147 17 14 14.9853 14 12.5C14 10.0147 16.0147 8 18.5 8C19.4361 8 20.3053 8.2862 21.0254 8.77539C21.1273 8.33127 21.5249 8 22 8ZM18.5 10C17.1193 10 16 11.1193 16 12.5C16 13.8807 17.1193 15 18.5 15C19.8807 15 21 13.8807 21 12.5C21 11.1193 19.8807 10 18.5 10Z"
        fill="currentColor"
      />
    </svg>
  )
})

CaseSensitiveIcon.displayName = "CaseSensitiveIcon"
